var _path, _path2, _line, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "-15 -12 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.960582 12.25L2.58558 5.75H22.4144L24.0394 12.25H0.960582Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12V22H15V12",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.85,
    y1: 12,
    x2: 21.85,
    y2: 23,
    stroke: "#7A7A7A",
    strokeWidth: 1.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25H23",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.728da6664a8bd1ef8dfe588a758271dd.svg";
export { ForwardRef as ReactComponent };